import { useCallback } from 'react';

import { useAppStore } from '@/store';
import { ToastType } from '@/store/toast/types';
import downloadFile from '@/utils/file/downloadFile';
import sendAiGenScreenActionAnalytics from '@/utils/analytics/sendAiGenScreenActionAnalytics';
import sendObjectApplyAnalytics from '@/utils/analytics/sendObjectApplyAnalytics';
import sendObjectExportAnalytics from '@/utils/analytics/sendObjectExportAnalytics';
import {
  AiGenScreenAction,
  type ScreenType,
  AnalyticsSettings,
} from '@/types/analytics';
import { isDesktop } from '@/consts/device';

import type { IAppStore } from '@/store';
import type { ContentFile } from '@/types';

const selector = (store: IAppStore) => ({
  showToast: store.showToast,
});

type UseDownloadFlowOptions = {
  screenType: ScreenType;
};

const useDownloadFlow = ({ screenType }: UseDownloadFlowOptions) => {
  const { showToast } = useAppStore(selector);

  const handleDownload = useCallback(
    async (file: ContentFile, analyticsSettings?: AnalyticsSettings) => {
      sendAiGenScreenActionAnalytics({
        action: AiGenScreenAction.DOWNLOAD,
        screen_type: screenType,
        settings: analyticsSettings,
      });
      if (isDesktop) sendObjectApplyAnalytics();
      sendObjectExportAnalytics();

      await downloadFile({ file });
      showToast('Downloaded successfully', ToastType.Success);
    },
    [screenType, showToast]
  );

  return { handleDownload };
};

export default useDownloadFlow;
